module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "app-screenshots.cfe499dd.png" + "?" + Date.now();